import { Eye, EyeOff } from "lucide-react";
import TemplatePicker from "@/components/TemplatePicker";

export default function RenderOptionsPanel({
  templates,
  template,
  anonymize,
  showBullets,
  onTemplateChange,
  onToggleAnonymize,
  onToggleBullets,
}) {
  return (
    <div
      className="swiss-card p-6 mb-6 max-w-[920px] mx-auto fade-in"
      data-testid="render-options-panel"
    >
      <TemplatePicker
        templates={templates}
        selected={template}
        onChange={onTemplateChange}
        label="Template for this download"
      />
      <div className="mt-5 pt-4 border-t border-[var(--border-default)] flex flex-wrap items-center gap-4">
        <button
          type="button"
          onClick={onToggleAnonymize}
          className={`btn-ghost ${
            anonymize ? "text-[var(--brand-primary)]" : ""
          }`}
          data-testid="toggle-anonymize-render"
        >
          {anonymize ? (
            <EyeOff className="w-4 h-4" strokeWidth={1.5} />
          ) : (
            <Eye className="w-4 h-4" strokeWidth={1.5} />
          )}
          ANONYMIZE: {anonymize ? "ON" : "OFF"}
        </button>
        <button
          type="button"
          onClick={onToggleBullets}
          className={`btn-ghost ${
            !showBullets ? "text-[var(--brand-primary)]" : ""
          }`}
          data-testid="toggle-bullets-render"
        >
          {showBullets ? (
            <Eye className="w-4 h-4" strokeWidth={1.5} />
          ) : (
            <EyeOff className="w-4 h-4" strokeWidth={1.5} />
          )}
          BULLETS: {showBullets ? "SHOWN" : "HIDDEN"}
        </button>
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--text-muted)] ml-auto">
          Applied to next PDF / DOCX download
        </span>
      </div>
    </div>
  );
}
